export default "__VITE_ASSET__DbDgOKfk__"